import { useState } from "react";
import { useDispatch } from "react-redux";

import LoginIcon from "@mui/icons-material/Login";
import { Box, Typography, Grid2, Paper, IconButton } from "@mui/material";

import { ActionButton } from "components/ActionButton";
import { Tooltip } from "components/Tooltip";
import { FrmTextField } from "components/formFields/FrmTextField";
import { ButtonProgress } from "components/utility/ButtonProgress";
import { VSpace } from "components/utility/VSpace";

import { i18n } from "services/i18nService";
import { forgotPassword } from "services/sosInventoryService/sosApi";

import { openAlert } from "globalState/alertSlice";

const sx = {
  paper: { p: 4, width: "40rem", display: "flex", justifyContent: "center" },
  background: {
    minHeight: "100vh",
    width: "100%",
    backgroundImage: "linear-gradient(#b0c8f6, #5b8dee)",
    justifyContent: "center",
    alignItems: "center",
  },
};

export function ForgotPassword() {
  const [email, setEmail] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  async function handleSubmit(e) {
    e?.preventDefault();
    setIsLoading(true);
    const { success } = await forgotPassword(email);
    if (success) {
      const message = i18n("password.ForgotPasswordSubmitMessage");
      dispatch(openAlert({ type: "success", message }));
      setEmail(null);
    }
    setIsLoading(false);
  }

  return (
    <Grid2 container spacing={0} sx={sx.background}>
      <Paper sx={sx.paper} elevation={5}>
        <Box sx={{ minWidth: "30rem" }} m={2} mb={0}>
          <Box mb={2}>
            <Typography variant="h3">
              {i18n("password.Forgot.title")}
            </Typography>
          </Box>
          <Box>
            <form onSubmit={handleSubmit}>
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                mb={2}
              >
                <FrmTextField
                  required
                  type="email"
                  label={i18n("frmLabel.Email")}
                  value={email}
                  onValueChange={(_, value) => setEmail(value)}
                  disabled={isLoading}
                />
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Tooltip title={i18n("password.GoBackToLogin")}>
                    <IconButton component="a" href="/login" size="large">
                      <LoginIcon />
                    </IconButton>
                  </Tooltip>
                  <div style={{ position: "relative" }}>
                    <ActionButton type="submit" disabled={isLoading}>
                      {i18n("password.RequestReset")}
                    </ActionButton>
                    {isLoading && <ButtonProgress />}
                  </div>
                </Box>
              </Box>
            </form>
          </Box>
          <VSpace space={1} />
        </Box>
      </Paper>
    </Grid2>
  );
}
